import './App.css';
import Header from './components/Header';
import HeroProfessional from './components/HeroProfessional';
import PortfolioProfessional from './components/PortfolioProfessional';
import ServicesProfessional from './components/ServicesProfessional';
import BuildingMaterials from './components/BuildingMaterials';
import About from './components/About';
import Certifications from './components/Certifications';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import { Toaster } from './components/ui/sonner';

function AppProfessional() {
  return (
    <div className="App">
      <Header />
      <HeroProfessional />
      <PortfolioProfessional />
      <ServicesProfessional />
      <BuildingMaterials />
      <About />
      <Certifications />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppFloat />
      <Toaster />
    </div>
  );
}

export default AppProfessional;